<ng-progress
  #progressBar
  [trickleSpeed]="10"
  [speed]="10"
  [spinner]="false"
  color="#465dff"
></ng-progress>

<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="ball-scale"
  [fullScreen]="true"
  ><p style="color: white">Cargando...</p></ngx-spinner
>

<router-outlet />
